var StickyButton = (function ($) {

    var initPdpAddToCart = function () {
        const pdpAddToCartButton = document.getElementById('addToCartButton');
        const pdpAddToCartButtonProxy = document.getElementById('proxyAddToCartButton');
        init(pdpAddToCartButton, pdpAddToCartButtonProxy);
    };

    var init = function (original, proxy) {
        proxy.className = original.className;

        // hide proxy button when the original one is visible
        hideProxyIfOriginalVisible(original, proxy);

        // original button click imitation
        passTheClick(original, proxy);
    };

    // hide proxy button when the original one is visible
    var hideProxyIfOriginalVisible = function (original, proxy) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                   proxy.classList.add('hidden');
                } else {
                    proxy.classList.remove('hidden');
                }
            });
        });
        observer.observe(original);
    };

    // original button click imitation
    var passTheClick = function (original, proxy) {
        proxy.addEventListener('click', () => {
            original.click();
        });
    }

    return {
        init: init,
        initPdpAddToCart: initPdpAddToCart
    };
}) (jQuery);